export const formatRelativeTime = (epochMs) => {
    const diff = Math.max(0, Date.now() - epochMs);
    const minutes = Math.floor(diff / 60_000);
    if (minutes < 1)
        return "just now";
    if (minutes < 60)
        return `${minutes} minute${minutes === 1 ? "" : "s"} ago`;
    const hours = Math.floor(minutes / 60);
    if (hours < 24)
        return `${hours} hour${hours === 1 ? "" : "s"} ago`;
    const days = Math.floor(hours / 24);
    if (days < 7)
        return `${days} day${days === 1 ? "" : "s"} ago`;
    const weeks = Math.floor(days / 7);
    return `${weeks} week${weeks === 1 ? "" : "s"} ago`;
};
//# sourceMappingURL=formatRelativeTime.js.map